import { useEffect, useRef } from 'react';
import type { MultiLang } from '../../config';

interface Props {
    lang: MultiLang;
    screenName: string;
    height: number;
}

interface TwitterWidgets {
    widgets: { load: (element?: HTMLElement) => void };
}

declare global {
    interface Window {
        twttr?: TwitterWidgets;
    }
}

const WIDGETS_URL = 'https://platform.twitter.com/widgets.js';

/**
 * The embedded profile timeline, rendered by Twitter's own widgets.js: the
 * script turns the anchor into the timeline, and the anchor stays a plain link
 * to the profile if the script cannot load.
 */
const TwitterTimeline = (props: Props) => {
    const { lang, screenName, height } = props;
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const container = ref.current;
        if (container === null) {
            return;
        }
        container.innerHTML = '';
        const anchor = document.createElement('a');
        anchor.className = 'twitter-timeline';
        anchor.href = `https://twitter.com/${screenName}`;
        anchor.dataset.height = String(height);
        anchor.dataset.lang = lang;
        anchor.textContent = `Tweets by ${screenName}`;
        container.appendChild(anchor);
        if (window.twttr) {
            window.twttr.widgets.load(container);
        } else if (document.querySelector(`script[src="${WIDGETS_URL}"]`) === null) {
            const script = document.createElement('script');
            script.src = WIDGETS_URL;
            script.async = true;
            document.body.appendChild(script);
        }
    }, [lang, screenName, height]);

    return <div ref={ref} />;
};

export default TwitterTimeline;
